export const AuthenticatedPaths = Object.freeze({
    HOME: '/home',
    SYSTEMS: '/systems',
    STUDIES: '/studies',
    MY_ACCOUNT: '/my-account',
    EMAILS: '/my-account/emails',
    CHANGE_PASSWORD: '/my-account/change-password',
    REGISTRATION_SUCCESS: '/my-account/registration-success',
    RECENT_ACTIVITY: '/my-account/recent-activity',
    VAULT_INVITES: '/vault-invites',
});

export const UnauthenticatedPaths = Object.freeze({
    ERROR: '/error',
    FORGOT_PASSWORD: '/forgot-password',
    CHANGE_PASSWORD: '/change-password',
    CHANGE_USERNAME: '/change-username',
    REGISTER: '/register',
    SELF_REGISTER: '/self-register',
    LOGIN: '/',
    LEARN_MORE: '/learn-more',
});
